import { EMAIL_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
export function identifyGenericChannelIdFromRecipients(recipients) {
  const firstRecipient = recipients.get(0);
  if (firstRecipient) {
    return firstRecipient.genericChannelId ? firstRecipient.genericChannelId : EMAIL_GENERIC_CHANNEL_ID;
  }
  return null;
}